enum GeneralListType {
  Category,
  Search,
  Personal,
  None
}

export default GeneralListType
